<section id="weekly" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="weekly-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="weekly-heading">{{ 'weekly.title' | reportT }}</h2>
      <p class="section__desc">{{ 'weekly.subtitle' | reportT }}</p>
    </div>
  </div>

  <article class="card weekly-card" data-print-block>
    <div class="card-content weekly">
      <ul class="chart-legend weekly__legend">
        @for (entry of legend(); track entry.code) {
          <li class="chart-legend__item">
            <span class="chart-legend__swatch" [attr.data-cc]="entry.code"
                  [style.background-color]="entry.color" aria-hidden="true"></span>
            <span class="chart-legend__label" dir="auto">{{ entry.shortCode }}</span>
          </li>
        }
      </ul>

      <!-- Les libellés de compétences demandent de la place ; en dessous, le
           graphique défile dans ce conteneur pour que le corps de page, lui,
           ne défile jamais. -->
      <div class="chart-scroll">
        <div class="chart-min chart-min--620">
          <!-- `codePrefix` vide : les codes du modèle sont déjà affichables. -->
          <s2e-weekly-chart
            [bars]="subject().charts.weekly"
            [weeks]="planWeeks()"
            [weekLabels]="weekLabels()"
            [theme]="chrome.theme()"
            [rtl]="chrome.rtl()"
            [codeDir]="codeDir()"
            [scheduledInLabel]="scheduledIn()"
            [ariaLabel]="ariaLabel()"
            codePrefix=""
          />
        </div>
      </div>

      <!-- Le calendrier énoncé — le graphique dit quand, ceci dit quoi. -->
      <div class="week-grid">
        @for (week of subject().plan; track week.week) {
          <div class="week-card reveal reveal--fade-up" s2eReveal [revealDelay]="$index * 80">
            <!-- Aucune couleur sur la semaine : les pastilles appartiennent
                 aux compétences. -->
            <p class="week-card__title">{{ weekLabels()[week.week - 1] }}</p>
            @if (week.competencies.length > 0) {
              <ul class="week-list">
                @for (item of week.competencies; track item.competencyId) {
                  <li class="week-item">
                    <div class="week-item__row">
                      <span class="week-item__code-wrap">
                        <span class="week-item__swatch" [attr.data-cc]="item.code"
                              [style.background-color]="item.color" aria-hidden="true"></span>
                        <span class="week-item__code" dir="auto">{{ item.shortCode }}</span>
                      </span>
                      <!-- La cible est l'acquisition, pas un pourcentage. -->
                      <span class="badge badge--danger badge--sm">{{ 'competency.notAcquired' | reportT }}</span>
                    </div>
                    <p class="week-item__name">{{ item.title }}</p>
                  </li>
                }
              </ul>
            } @else {
              <!-- Une semaine sans compétence garde sa carte : le plan compte
                   autant de semaines qu'annoncé, en sauter une le ferait
                   paraître plus court qu'il n'est. -->
              <p class="insight-card__empty">{{ 'chart.noData' | reportT }}</p>
            }
          </div>
        }
      </div>
    </div>
  </article>
</section>
